import { useMemo } from "react";

import { Autocomplete, TextField } from "@mui/material";

import { usePlatformList } from "./hooks";
import { type TicketAsset } from "./types";

type Props = {
  onChange: (data: TicketAsset) => void;
  selectedItem: TicketAsset | null;
  platform: string;
  assets: TicketAsset[];
};

export const AssetSelector = ({ onChange, selectedItem, platform, assets }: Props) => {
  const platformList = usePlatformList();
  const label = platformList.find((p) => p.value === platform)?.label || "";

  const value = useMemo(
    () => assets.find((asset) => asset.identifier === selectedItem?.identifier) || null,
    [assets, selectedItem]
  );

  return (
    <Autocomplete
      options={assets}
      getOptionLabel={(option) => {
        if (option.label) {
          return option.label;
        }

        return option.identifier;
      }}
      fullWidth
      disablePortal
      size="medium"
      onChange={(_, newValue: TicketAsset | null) => {
        if (newValue) {
          onChange(newValue);
        }
      }}
      value={value}
      data-cy="asset-selector"
      disableClearable={value !== null}
      renderInput={(params) => (
        <TextField
          {...params}
          size="medium"
          label={label}
          required
          variant="outlined"
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
      )}
    />
  );
};
